module.exports = __webpack_public_path__ + "Announcement_en@2x.bb69cbf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Announcement/images/Announcement_en@2x.png
// module id = z9ID
// module chunks = 0